 // Import the functions you need from the SDKs you need
 import { initializeApp } from "firebase/app";
 import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
 import { getFirestore } from "firebase/firestore";
 import { getDatabase } from "firebase/database";

 // Your web app's Firebase configuration
 const firebaseConfig = {
   apiKey: process.env['REACT_APP_FIREBASE_API_KEY'],
   authDomain: process.env['REACT_APP_FIREBASE_AUTH_DOMAIN'],
   projectId: process.env['REACT_APP_FIREBASE_PROJECT_ID'],
   storageBucket: process.env['REACT_APP_FIREBASE_STORAGE_BUCKET'],
   messagingSenderId: process.env['REACT_APP_FIREBASE_MESSAGING_SENDER_ID'],
   appId: process.env['REACT_APP_FIREBASE_APP_ID'],
   databaseURL: process.env['REACT_APP_FIREBASE_DATABASE_URL'],
 };

 // Initialize Firebase
 const app = initializeApp(firebaseConfig);
 const auth = getAuth(app);
 const provider = new GoogleAuthProvider();
 const db = getFirestore(app); // Initialize Firestore
 const database = getDatabase(app);

 export { auth, provider, signInWithPopup, db, database };